import React from 'react';
import { Footer, FooterLink, List, ListItem } from '@deere/ux.uxframe-react';

function DeereFooter(){
    return  <Footer>
        <List className="nav">
            <ListItem>
                <FooterLink href="http://ux.deere.com/">Home</FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="http://ux.deere.com/other-pages/contact-us/">
                    Contact Us
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://github.deere.com/ux/uxframe" rel="noopener noreferrer" target="_blank">
                    GitHub
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://www.yammer.com/johndeere.com/#/threads/inGroup?type=in_group&amp;feedId=15611067&amp;view=all" rel="noopener noreferrer" target="_blank">
                    Yammer
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://www.flowdock.com/app/john-deere/ux" rel="noopener noreferrer" target="_blank">
                    Flowdock
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://johndeere.cvent.com/pub/eMarketing/Pages/SignUp.aspx?p=2a69c63b-ace1-454f-bbe3-e371c5a09d58&amp;m=" rel="noopener noreferrer" target="_blank">
                    Subscribe to our Newsletter
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://www.deere.com/en/privacy-and-data/" rel="noopener noreferrer" target="_blank">
                    Privacy & Data
                </FooterLink>
            </ListItem>
            <ListItem>
                <FooterLink href="https://www.deere.com/en/privacy-and-data/terms/" rel="noopener noreferrer" target="_blank">
                    Terms of Use
                </FooterLink>
            </ListItem>
        </List>
    </Footer>;
}

export default DeereFooter;